import axios from 'axios';
import { normalizeKoreanData, normalizeKoreanText } from '../utils/fixKoreanText';
const isLocalhostHost = (hostname) => hostname === 'localhost' || hostname === '127.0.0.1';
const buildOriginWithPort = (protocol, hostname, port) => `${protocol}//${hostname}:${port}`;
const getApiBaseUrl = () => {
    const envUrl = process.env.REACT_APP_API_URL;
    const currentHost = window.location.hostname;
    const isCurrentLocal = isLocalhostHost(currentHost);
    if (!isCurrentLocal) {
        return window.location.origin;
    }
    if (envUrl) {
        try {
            const parsedEnvUrl = new URL(envUrl);
            const envHost = parsedEnvUrl.hostname;
            const isEnvLocal = isLocalhostHost(envHost);
            if (isEnvLocal && !isCurrentLocal) {
                const envPort = parsedEnvUrl.port || (parsedEnvUrl.protocol === 'https:' ? '443' : '80');
                return buildOriginWithPort(window.location.protocol, currentHost, envPort);
            }
            if (!(isEnvLocal && !isCurrentLocal)) {
                return envUrl;
            }
        }
        catch {
            return envUrl;
        }
    }
    if (isCurrentLocal) {
        return window.location.origin;
    }
    return window.location.origin;
};
export const API_BASE_URL = getApiBaseUrl();
const api = axios.create({
    baseURL: API_BASE_URL,
    timeout: 120000,
});
api.isAxiosError = axios.isAxiosError;
api.interceptors.request.use((config) => {
    const token = sessionStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    const isFormData = typeof FormData !== 'undefined' && config.data instanceof FormData;
    if (isFormData) {
        delete config.headers['Content-Type'];
        delete config.headers['content-type'];
    }
    else if (!config.headers['Content-Type'] && !config.headers['content-type']) {
        config.headers['Content-Type'] = 'application/json';
    }
    return config;
}, (error) => Promise.reject(error));
api.interceptors.response.use((response) => {
    var _a;
    const responseType = (_a = response.config) === null || _a === void 0 ? void 0 : _a.responseType;
    if (responseType === 'blob' || responseType === 'arraybuffer') {
        return response;
    }
    response.data = normalizeKoreanData(response.data);
    return response;
}, (error) => {
    var _a;
    if (!error.response) {
        return Promise.reject({
            message: '서버 연결에 실패했습니다. 네트워크 연결을 확인해 주세요.',
            originalError: error,
        });
    }
    const responseType = (_a = error.config) === null || _a === void 0 ? void 0 : _a.responseType;
    if (error.response.data && responseType !== 'blob' && responseType !== 'arraybuffer') {
        error.response.data = normalizeKoreanData(error.response.data);
    }
    if (error.response.status === 401) {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('userRole');
        sessionStorage.removeItem('name');
    }
    return Promise.reject(error);
});
export const checkApiStatus = async () => {
    try {
        const response = await api.get('/api/status', { timeout: 5000 });
        return {
            online: true,
            message: normalizeKoreanText(response.data.message || 'API 서버가 정상적으로 응답하고 있습니다.'),
        };
    }
    catch {
        return {
            online: false,
            message: '서버에 연결할 수 없습니다. 서버가 실행 중인지 확인해 주세요.',
        };
    }
};
export default api;
